'use strict';
module.exports = require('./usetoast.js');